import { alpha, styled } from '@mui/material';
import Menu from '@mui/material/Menu';

const StyledMenu = styled(({ horizontalAlign = 'right', verticalAnchorOrigin = 'bottom', ...restProps }) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: verticalAnchorOrigin,
            horizontal: horizontalAlign,
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: horizontalAlign,
        }}
        {...restProps}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        border: '1px solid var(--border-color)',
        marginTop: theme.spacing(1),
        // minWidth: 180,
        backgroundImage:
            theme.palette.mode === 'light'
                ? ''
                : 'linear-gradient(rgba(200, 200, 200, 0.16), rgba(200, 200, 200, 0.16))',
        color: theme.palette.mode === 'light' ? 'rgb(56,56,56)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0 9px',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            },
        },
    },
}));

export default StyledMenu;
